<template>
  <div class="loading-overlay">
    <div class="loading-overlay__loader">
      <lottie
        :options="{ animationData: LoadingAnimation }"
        :width="32"
        :height="32"
      />
    </div>
  </div>
</template>

<script>
import LoadingAnimation from "@/assets/animations/ui/loading.json"
import Lottie from "vue-lottie"

export default {
  components: {
    Lottie,
  },
  data: function () {
    return {
      LoadingAnimation,
    }
  },
}
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  z-index: 100;
}

.loading-overlay__loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/overlays/LoadingOverlay.vue